export const ContextDashboards = 'Dashboards';
